const CARD = Object.freeze({
  amex: 'AMEX',
  masterCard: 'MasterCard',
  mastero: 'Mastero',
  visa: 'visa',
});

export default CARD;
